<template>
  <section
    class="relative h-screen flex flex-col justify-center items-center text-center bg-cover bg-center"
    :style="{ backgroundImage: `url(${heroBackground})` }"
  >
    <!-- Overlay for better text visibility -->
    <div class="absolute inset-0 bg-black bg-opacity-50 -z-10"></div>

    <!-- Hero content -->
    <div class="text-white px-6 lg:px-12 mt-80 lg:mt-48">
      <h1
        class="uppercase text-5xl xl:text-7xl font-bold mb-6 text-white text-shadow-10-black"
      >
        Mobil Mászófal
      </h1>
      <h2
        class="text-lg xl:w-3/4 mx-auto leading-relaxed mb-8 text-white text-shadow-10-black"
      >
        Felejthetelen élmény, garantált szórakozás!
      </h2>
      <a
        href="#contact"
        class="bg-green hover:bg-green-dark text-white font-semibold py-3 px-6 rounded-lg shadow-[0_0_10px_black] transition transform hover:-translate-y-1"
      >
        Foglalja le most!
      </a>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      heroBackground: require("@/assets/images/hero/background.webp"),
    };
  },
};
</script>

<style>
/* Színek definiálása */
.bg-green {
  background-color: #5a9314; /* Gombháttér zöld */
}

.bg-green-dark {
  background-color: #05650c; /* Sötétebb zöld */
}

.text-green {
  color: #6eb31a; /* Fő zöld */
}

.bg-footer {
  background-color: #033006; /* Footer háttér */
}

.text-footer {
  color: #c4d600; /* Footer szöveg */
}

.text-white {
  color: #ffffff !important; /* Fehér szöveg biztosítása */
}

/* Reszponzív háttérkép */
.bg-cover {
  background-size: cover;
  background-position: center;
}

/* H1 zöld körvonal */

.text-shadow-10-black {
  text-shadow: 0 0 10px black, 0 0 10px black;
}
</style>
